import { createReducer, } from 'typesafe-actions';

import { fetchInfo, } from './actions';

const infoInitialState = {
    isLoading: false,
    isError: false,
    errorMessage: null,
    // TODO PB Ask about business logic which better default closed or opened bookstore.
    data: undefined,
};

const infoReducer = createReducer(infoInitialState)
    .handleAction(fetchInfo.request, (state,) => ({ ...state, isLoading: true, }))
    .handleAction(fetchInfo.success, (state, action) => ({
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
    }))
    .handleAction(fetchInfo.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
    }));

export default infoReducer;
